"use client"

import React, { Suspense } from 'react'
import { ADMIN_TAB_LINKS, AdminTabLink, SEARCH_PARAMS_TAB_KEY } from '../constants/admin-tabs'
import Link from 'next/link'
import { cn, buildRegionUrl } from '@/shared/lib/utils'
import { useRegion } from '@/shared/hooks/use-region'
import { useSearchParams } from 'next/navigation'

function AdminTabsContent({ tab }: { tab?: AdminTabLink }) {
    const { regionSlug } = useRegion()
    const searchParams = useSearchParams()
    const rawTab = tab || (searchParams.get(SEARCH_PARAMS_TAB_KEY) as AdminTabLink | 'tools-supplies' | null) || 'partners'
    const currentTab = rawTab === 'tools-supplies' ? 'work-scopes' : rawTab
    
    // Determine default tab for active state
    const defaultTab: AdminTabLink = 'partners'
    
    return (
        <div className="flex items-center justify-center gap-5">
            {ADMIN_TAB_LINKS.map((link) => {
                // Build region-aware URL with tab parameter
                const href = regionSlug
                    ? buildRegionUrl(regionSlug, '/admin', { [SEARCH_PARAMS_TAB_KEY]: link.value })
                    : `/admin?${SEARCH_PARAMS_TAB_KEY}=${link.value}`
                
                const isActive = link.value === currentTab || (!currentTab && link.value === defaultTab)
                
                return (
                    <Link
                        key={link.value}
                        href={href}
                        className={cn(
                            'w-[100px] text-center pb-0.5 border-b-[3px] border-transparent',
                            {
                                "border-primary text-primary font-medium": isActive,
                            }
                        )}
                    >
                        {link.label}
                    </Link>
                )
            })}
        </div>
    )
}

function AdminTabs({ tab }: { tab?: AdminTabLink }) {
    return (
        <Suspense fallback={
            <div className="flex items-center justify-center gap-5">
                {ADMIN_TAB_LINKS.map((link) => (
                    <div
                        key={link.value}
                        className="w-[100px] text-center pb-0.5 border-b-[3px] border-transparent"
                    >
                        {link.label}
                    </div>
                ))}
            </div>
        }>
            <AdminTabsContent tab={tab} />
        </Suspense>
    )
}

export default AdminTabs

